<template>
  <div class="about-afu hoverable">
    <router-link class="conoce-mas" to="/p/archivos">
      Nosotros
    </router-link>
    <div class="title-about">
      <router-link to="/p/contacto">
        El Archivo Fotografía Urbana es una fundación dedicada
        a la conservación, el registro, la investigación y la difusión de la
        memoria visual venezolana.
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  props: {
    title: String,
  },
  computed: {
    homePage() {
      if (this.$route.path === '/') {
        return true
      } else {
        return false
      }
    },
  },
}
</script>

<style scoped>
  a,
  a:link,
  a:visited,
  a:active {
    color: #000000;
    opacity: 1.0;
    text-decoration: none;
  }
  a:hover {
    color: #000000;
    opacity: 0.5;
    text-decoration: none;
  }
  .about-afu {
    height: 480px;
    /*width: 75%;*/
    position: relative;
    background-image: linear-gradient(
180deg
, rgba(255, 255, 255, 0.35) 0%, #FFFFFF 100%), url(../assets/about-afu.jpg);
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    transition: all 0.3s ease-in-out;
    text-align: left;
  }
  .conoce-mas {
      font-family: Raleway;
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 21px;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      padding-left: 40px;
      margin-bottom: 20px;
  }
  .title-about {
    width: 80%;
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 36px;
    line-height: 40px;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 100px;
  }
  .about-afu:hover{
      box-shadow: 0px 0px 60px 1px rgba(131,128,122,0.39);
      transition: all 0.3s ease-in-out;
      z-index: 1;
  }
  @media only screen and (max-width:1255px){
      .img-aliados{
          height: 120px;
          padding: 10px;
      }
  }


  @media only screen and (max-width: 1150px){

      .menu{
          display: none;
      }
      .res-menu{
          display: inline !important;
          font-size: 30px;
          padding-top: 10px;
          cursor: pointer;
      }

  }

  @media only screen and (max-width: 640px){

      .logo-text {
          width: 62px;
          font-family: Raleway;
          font-style: normal;
          font-weight: bold;
          font-size: 10px;
          line-height: 11px;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          padding-left: 9px;
          padding-top: 11px;
      }

      .search {
          width: 160px;
      }

      .title-about{
          width: 100%;
          font-size: 21px;
          line-height: 1.4em;
      }

      .about-afu{
          width: 100%;
          height: 380px;
      }
      .card-post{
          height: auto;
      }
      .img-gradient, .card-post-img-2{
          height: 180px;
      }


      .yellow{
          width: 100% !important;
      }
      .home-slider{
          width: 100%;
          height: auto;
      }
      .slideshow-container {
          height: auto !important;
      }
      .img-aliados{
          height: 90px;
          padding: 1px;
      }
      .footer-container{
          padding-left: 40px;
          flex-direction: column;
      }
      footer{
          height: auto;
      }
  }
  @media only screen and (max-width:1255px){
      .img-aliados{
          height: 120px;
          padding: 10px;
      }
  }


  @media only screen and (max-width: 1150px){

      .menu{
          display: none;
      }
      .res-menu{
          display: inline !important;
          font-size: 30px;
          padding-top: 10px;
          cursor: pointer;
      }

  }

  @media only screen and (max-width: 640px){

      .logo-text {
          width: 62px;
          font-family: Raleway;
          font-style: normal;
          font-weight: bold;
          font-size: 10px;
          line-height: 11px;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          padding-left: 9px;
          padding-top: 11px;
      }

      .search {
          width: 160px;
      }

      .title-about{
          width: 100%;
          font-size: 21px;
          line-height: 1.4em;
      }

      .about-afu{
          width: 100%;
          height: 380px;
      }
      .card-post{
          height: auto;
      }
      .img-gradient, .card-post-img-2{
          height: 180px;
      }


      .yellow{
          width: 100% !important;
      }
      .home-slider{
          width: 100%;
          height: auto;
      }
      .slideshow-container {
          height: auto !important;
      }
      .img-aliados{
          height: 90px;
          padding: 1px;
      }
      .footer-container{
          padding-left: 40px;
          flex-direction: column;
      }
      footer{
          height: auto;
      }
  }
</style>
